import {} from 'react';

const VideoIcon = () => (
  <svg
    width="22"
    height="23"
    // viewBox="0 0 22 23"
    viewBox="0 0 300 300"
    version="1.1"
    clipRule="evenodd"
    strokeLinejoin="round"
    strokeMiterlimit="2"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M241.042,285.833l-107.084,0c-14.583,0 -26.666,-12.083 -26.666,-26.666l-0,-218.334c-0,-14.583 12.083,-26.666 26.666,-26.666l107.5,-0c14.584,-0 26.667,12.083 26.667,26.666l0,218.75c-0.417,14.584 -12.083,26.25 -27.083,26.25Z"
      fill="#4a5468"
      fillRule="nonzero"
    />
    <path
      d="M236.875,144.167l-78.75,-45.417c-4.167,-2.5 -9.583,0.417 -9.583,5.417l-0,90.833c-0,5 5.416,7.917 9.583,5.417l78.75,-45.417c4.167,-2.083 4.167,-8.333 0,-10.833Z"
      fill="#2DD28D"
      fillRule="nonzero"
    />
    <path
      d="M96.875,39.167l-12.083,-0c-11.667,-0 -21.25,9.583 -21.25,21.25l-0,187.083c-0,11.667 9.583,21.25 21.25,21.25l12.083,0l0,-229.583Z"
      fill="#4a5468"
      fillOpacity="0.8"
      fillRule="nonzero"
    />
    <path
      d="M53.542,84.583l-7.917,0c-7.5,0 -13.75,6.25 -13.75,13.75l0,123.75c0,7.5 6.25,13.75 13.75,13.75l7.917,0l-0,-151.25Z"
      fill="#4a5468"
      fillOpacity="0.6"
      fillRule="nonzero"
    />
  </svg>
);

export default VideoIcon;
